import { convertColorStringToRgb, PostloadedImage } from "@pm2/compat";
import { SlideCaption } from "./atom.slide-caption";
import * as styles from "./atom.slide.style";
import { Slide as SlideModel } from "@courses-pm2/api";

export type SlideProps = {
  isVisible: boolean;

  model: SlideModel;
};

export function Slide(props: SlideProps): React.JSX.Element {
  return (
    <div className={styles.root}>
      <div className={styles.imageWrapper}>
        <PostloadedImage
          className={styles.imageCls}
          src={props.model.src}
          width={props.model.width}
          height={props.model.height}
          alt=""
          loading={props.isVisible ? "eager" : "lazy"}
          sizes="min(100vw, 1110px)"
        />
        <SlideLink
          linkBackgroundColor={props.model.linkBackgroundColor}
          linkText={props.model.linkText}
          linkTextColor={props.model.linkTextColor}
          linkUrl={props.model.linkUrl}
        />
      </div>

      <SlideCaption caption={props.model.caption} />
    </div>
  );
}

function SlideLink(
  props: Pick<
    SlideModel,
    "linkBackgroundColor" | "linkText" | "linkTextColor" | "linkUrl"
  >,
): React.JSX.Element | null {
  if (!props.linkText || !props.linkUrl) {
    return null;
  }

  return (
    <a
      href={props.linkUrl}
      target="_blank"
      className={styles.link}
      style={styles.linkSurface.__override({
        color: convertColorStringToRgb(props.linkTextColor)?.toString(),
        background: convertColorStringToRgb(
          props.linkBackgroundColor,
        )?.toString(),
      })}
    >
      {props.linkText}
    </a>
  );
}
